var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84314 0C1.27281 0 0 1.27281 0 2.84314C0 4.41346 1.27281 5.68628 2.84314 5.68628H41.5098C43.0801 5.68628 44.3529 4.41346 44.3529 2.84314C44.3529 1.27281 43.0801 0 41.5098 0H2.84314ZM2.84314 16.4902C1.27281 16.4902 0 17.763 0 19.3333C0 20.9037 1.27281 22.1765 2.84314 22.1765H41.5098C43.0801 22.1765 44.3529 20.9037 44.3529 19.3333C44.3529 17.763 43.0801 16.4902 41.5098 16.4902H2.84314ZM2.84314 32.9804C1.27281 32.9804 0 34.2532 0 35.8235C0 37.3939 1.27281 38.6667 2.84314 38.6667H41.5098C43.0801 38.6667 44.3529 37.3939 44.3529 35.8235C44.3529 34.2532 43.0801 32.9804 41.5098 32.9804H2.84314Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.6f416905d83ef93e1022be8e924cc562.svg";
export { ForwardRef as ReactComponent };